import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { usePortHolidayAPI } from "modules/PortHolidays/usePortHolidayAPI"



export function useFetchPortHolidays({ locode, startDate, endDate }: {
  locode: string | undefined
  startDate: string | undefined
  endDate: string | undefined
}) {

  const { getPortHolidays } = usePortHolidayAPI()

  const {
    isLoading: isPortHolidaysLoading,
    isError: isPortHolidaysError,
    isSuccess: isPortHolidaysSuccess,
    data: portHolidaysData,
  } = useQuery({
    queryKey: ["portPredictor/getPortHolidays", { locode, startDate, endDate }],
    queryFn: ({ queryKey }) => {
      return getPortHolidays({
        locode: locode as string,
        startDate: startDate as string,
        endDate: endDate as string
      })
    },
    retry: (failureCount, error) => {
      const axiosError = error as AxiosError;
      if (axiosError?.response?.status === 500) {
        return false;
      }
      return failureCount < 3
    },
    enabled: !!(locode && startDate && endDate),
    staleTime: 20 * 60 * 1000,
  })

  return {
    portHolidaysData,
    isPortHolidaysLoading,
    isPortHolidaysError,
    isPortHolidaysSuccess,
  }
}
